import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImpersonationBarComponent } from '@tuition/shared/components/impersonation-bar/impersonation-bar.component';

const COMPONENTS = [
	ImpersonationBarComponent
];

@NgModule({
	declarations: COMPONENTS,
	imports: [
		CommonModule
	],
	exports: COMPONENTS
})
export class ImpersonationBarComponentModule {}
